import EditServicesPageContainer from './EditServicesPageContainer';

export default EditServicesPageContainer;



// WEBPACK FOOTER //
// ./src/components/pages/SelfCheckIn/EditServicesPage/index.js